import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Drawer,
  IconButton,
  Divider,
  Typography,
  Chip,
  Avatar,
  Badge,
  Collapse,
} from '@mui/material';
import {
  FaChartLine,
  FaFileInvoiceDollar,
  FaClipboardList,
  FaBed,FaCog,FaKey,
  FaUserCheck,
  FaUserClock,
  FaConciergeBell,
  FaUtensils,
  FaSwimmingPool,
  FaSpa,
  FaDumbbell,
  FaCar,
  FaWifi,
  FaChevronDown,
  FaChevronRight,
  FaPlus,
  FaList,
  FaShoppingCart,
  FaUsers,
  FaPercent,
} from 'react-icons/fa';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import logo from '../../assets/images/logo.png';

function HotelSidebar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();

  // Get user data from localStorage
  const getUserInfo = () => {
    try {
      const storedProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
      console.log('Retrieved user profile:', storedProfile);
      
      return {
        name: storedProfile.name || storedProfile.username || 'Hotel Admin',
        role: storedProfile.role || storedProfile.user_type || 'Hotel Staff',
        hotel: storedProfile.hotel_name || storedProfile.hotelcode || 'Hotel Management',
        avatar: storedProfile.avatar || "/static/images/avatar/1.jpg",
        hotelCode: storedProfile.hotelcode || storedProfile.hotel_code || 'HOTEL_001'
      };
    } catch (error) {
      console.error('Error retrieving user info:', error);
      return {
        name: 'Hotel Admin',
        role: 'Hotel Staff',
        hotel: 'Hotel Management',
        avatar: "/static/images/avatar/1.jpg",
        hotelCode: 'HOTEL_001'
      };
    }
  };

  const userInfo = getUserInfo();
const SERVICE_PROVIDERS=process.env.REACT_APP_VENDOR_SERVICE_PROVIDERS;

  const menuItems = [
    { 
      text: 'Dashboard', 
      icon: <FaChartLine />, 
      link: '/hotel/admin/dashboard',
      badge: null
    },
    { 
      text: 'Staff', 
      icon: <FaUserCheck />, 
      link: '/hotel/staff/record',
      badgeColor: 'warning'
    },
    { 
      text: 'Booking', 
      icon: <FaUserClock />,
      isDropdown: true,
      children: [
        { 
          text: 'Room Management', 
          icon: <FaBed />, 
          link: '/hotel/rooms/management',
        },
        { 
          text: 'Booking & Reservations', 
          icon: <FaUserClock />, 
          link: '/hotel/admin/AdminBookingDetails',
        },
        { 
          text: 'Set Room Discount', 
          icon: <FaPercent />, 
          link: '/hotel/admin/DiscountManagement',
        },
      ]
    },
    { 
      text: 'F&B Management', 
      icon: <FaUtensils />,
      isDropdown: true,
      children: [
        { 
          text: 'Menu Items & Inventory', 
          icon: <FaList />, 
          link: '/hotel/fb/HotelFBInventoryMgmt',
        },
        { 
            text: 'Table Management', 
          icon: <FaPlus />, 
          link: '/hotel/fb/HotelFBTableManagement',
        },
         { 
            text: 'Orders & Cancellations', 
          icon: <FaPlus />, 
          link: '/hotel/admin/HotelAdminFBMgmt',
        },

         { 
            text: 'Cancellations Report', 
          icon: <FaPlus />, 
          link: '/hotel/admin/FBCancelledOrdersReport',
        },
      
      ]
    },
    { 
      text: 'Create Facilities', 
      icon: <FaConciergeBell />, 
      link: '/hotel/rooms/FacilityCreation',
    },
    { 
      text: 'Reports & Analytics', 
      icon: <FaClipboardList />, 
      link: '/hotel/admin/StatisticsDashboard',
      badge: null
    },
    { 
      text: 'Customers', 
      icon: <FaUsers />, 
      link: '/hotel/admin/CustomerLoyaltyDashboard',
    },

{ 
  text: 'Settings', 
  icon: <FaCog />,
  isDropdown: true,
  children: [
    { 
      text: 'Reset Password', 
      icon: <FaKey />,
      link: '/hotel/admin/ResetPassword',
    },
    // { 
    //   text: 'Orders & Cancellations', 
    //   icon: <FaClipboardList />,
    //   link: '/hotel/admin/HotelAdminFBMgmt',
    // },
  ]
},
  ];

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const handleMenuItemClick = () => setDrawerOpen(false);
  
  const toggleDropdown = (menuText) => {
    setOpenMenus(prev => ({ ...prev, [menuText]: !prev[menuText] }));
  };

  const isParentSelected = (item) => {
    if (item.link && location.pathname === item.link) return true;
    if (item.children) {
      return item.children.some(child => location.pathname === child.link);
    }
    return false;
  };

  const renderMenuItems = () => (
    <List sx={{ px: 1.5 }}>
      {menuItems.map((item) => {
        const isSelected = isParentSelected(item);
        const isOpen = openMenus[item.text];
        
        return (
          <Box key={item.text}>
            <ListItem
              button
              component={item.isDropdown ? 'div' : Link}
              to={item.link}
              onClick={() => {
                if (item.isDropdown) {
                  toggleDropdown(item.text);
                } else {
                  handleMenuItemClick();
                }
              }}
              sx={{
                backgroundColor: isSelected && !item.isDropdown ? 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)' : 'transparent',
                borderRadius: '10px',
                paddingY: 1.5,
                paddingX: 2,
                marginY: 0.5,
                color: isSelected ? '#FFFFFF' : '#F5F9FF',
                position: 'relative',
                overflow: 'hidden',
                border: isSelected && !item.isDropdown ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid transparent',
                boxShadow: isSelected && !item.isDropdown ? '0 4px 12px rgba(21, 101, 192, 0.3)' : 'none',
                cursor: 'pointer',
                '&::before': isSelected && !item.isDropdown ? {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  height: '100%',
                  width: '4px',
                  backgroundColor: '#FFD700',
                  borderRadius: '0 4px 4px 0'
                } : {},
                '&:hover': {
                  backgroundColor: isSelected && !item.isDropdown ? 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)' : 'rgba(255, 255, 255, 0.15)',
                  transform: 'translateX(4px)',
                  transition: 'all 0.2s ease-in-out',
                  border: isSelected && !item.isDropdown ? '1px solid rgba(255, 255, 255, 0.3)' : '1px solid rgba(255, 255, 255, 0.1)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              <Box 
                sx={{ 
                  marginRight: 2, 
                  fontSize: '1.2rem',
                  opacity: isSelected ? 1 : 0.9,
                  color: isSelected ? '#FFFFFF' : '#E3F2FD',
                  filter: isSelected ? 'brightness(1.2)' : 'none',
                }}
              >
                {item.icon}
              </Box>
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  fontSize: '0.95rem',
                  fontWeight: isSelected ? 700 : 600,
                  letterSpacing: '0.2px',
                  color: isSelected ? '#FFFFFF' : '#F5F9FF',
                }}
              />
              {item.isDropdown && (
                <Box sx={{ 
                  ml: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  color: isSelected ? '#FFFFFF' : '#B3E5FC'
                }}>
                  {isOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
                </Box>
              )}
              {item.badge && !item.isDropdown && (
                <Chip
                  label={item.badge}
                  size="small"
                  color={item.badgeColor || 'primary'}
                  sx={{
                    height: 22,
                    fontSize: '0.75rem',
                    minWidth: 24,
                    fontWeight: 700,
                    backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.25)' : '',
                    color: isSelected ? '#FFFFFF' : 'inherit',
                    border: isSelected ? '1px solid rgba(255, 255, 255, 0.3)' : 'none',
                  }}
                />
              )}
            </ListItem>
            
            {/* Render dropdown children */}
            {item.isDropdown && (
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <Box sx={{ ml: 3, mr: 1, mt: 0.5, mb: 0.5 }}>
                  {item.children.map((child) => {
                    const isSubSelected = location.pathname === child.link;
                    return (
                      <ListItem
                        key={child.text}
                        button
                        component={Link}
                        to={child.link}
                        onClick={handleMenuItemClick}
                        sx={{
                          backgroundColor: isSubSelected ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                          borderRadius: '8px',
                          paddingY: 1,
                          paddingX: 2,
                          marginY: 0.25,
                          color: isSubSelected ? '#FFFFFF' : '#E8F4FD',
                          border: isSubSelected ? '1px solid rgba(255, 255, 255, 0.15)' : '1px solid transparent',
                          '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.15)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            transform: 'translateX(4px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        <Box 
                          sx={{ 
                            marginRight: 2, 
                            fontSize: '1rem',
                            opacity: 0.9,
                            color: isSubSelected ? '#FFFFFF' : '#BBDEFB',
                          }}
                        >
                          {child.icon}
                        </Box>
                        <ListItemText
                          primary={child.text}
                          primaryTypographyProps={{
                            fontSize: '0.85rem',
                            fontWeight: isSubSelected ? 600 : 500,
                            color: isSubSelected ? '#FFFFFF' : '#E8F4FD',
                          }}
                        />
                      </ListItem>
                    );
                  })}
                </Box>
              </Collapse>
            )}
          </Box>
        );
      })}
    </List>
  );

  return (
    <>
      {/* Mobile menu button */}
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          left: 16,
          zIndex: 1301,
          display: { xs: 'block', md: 'none' },
        }}
      >
        <IconButton 
          color="inherit" 
          onClick={toggleDrawer}
          sx={{
            backgroundColor: '#1565C0',
            boxShadow: '0 2px 8px rgba(21, 101, 192, 0.4)',
            '&:hover': {
              backgroundColor: '#0D47A1',
              transform: 'scale(1.05)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <MenuIcon sx={{ color: 'white' }} />
        </IconButton>
      </Box>

      {/* Drawer for mobile */}
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={toggleDrawer}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width: 300,
            backgroundColor: '#0A1929',
            backgroundImage: 'linear-gradient(180deg, #0A1929 0%, #132F4C 100%)',
            color: 'white',
            border: 'none',
            boxSizing: 'border-box',
            boxShadow: '4px 0 20px rgba(0, 0, 0, 0.3)',
          },
        }}
      >
        <Box
          sx={{
            width: 300,
            height: '100%',
            background: 'linear-gradient(180deg, #0A1929 0%, #132F4C 100%)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* Header with user info */}
          <Box sx={{ p: 2, pb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <img src={logo} alt="Hotel Logo" style={{ 
                width: 44, 
                height: 44, 
                marginRight: 12, 
                borderRadius: '10px',
                border: '2px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
              }} />
              <Box>
                <Typography variant="h6" sx={{ 
                  fontSize: '1.2rem', 
                  fontWeight: 'bold', 
                  color: '#FFFFFF',
                  textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
                }}>
                  e-Neurons
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: '#B3E5FC',
                  fontWeight: 500,
                  fontSize: '0.75rem'
                }}>
                   Service Providers: {SERVICE_PROVIDERS}
                </Typography>
              </Box>
            </Box>
            
            {/* User profile */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              backgroundColor: 'rgba(255, 255, 255, 0.12)', 
              p: 1.5, 
              borderRadius: 3, 
              mb: 2,
              border: '1px solid rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)'
            }}>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                variant="dot"
                color="success"
              >
                <Avatar sx={{ 
                  width: 44, 
                  height: 44, 
                  mr: 1.5,
                  border: '2px solid rgba(255, 255, 255, 0.2)'
                }} src={userInfo.avatar}>
                  {userInfo.name.charAt(0)}
                </Avatar>
              </Badge>
              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle2" sx={{ 
                  fontWeight: 700, 
                  color: '#FFFFFF',
                  fontSize: '0.95rem'
                }}>
                  {userInfo.name}
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: '#E1F5FE',
                  fontWeight: 500
                }}>
                  {userInfo.role}
                </Typography>
                <Typography variant="caption" sx={{ 
                  display: 'block',
                  color: '#B2EBF2',
                  fontWeight: 400,
                  fontSize: '0.7rem'
                }}>
                  {userInfo.hotelCode}
                </Typography>
              </Box>
              <IconButton sx={{ 
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                }
              }} size="small">
                <NotificationsIcon />
              </IconButton>
            </Box>

            {/* Quick Stats */}
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, mb: 1 }}>
              <Box sx={{ 
                textAlign: 'center', 
                p: 1.5, 
                backgroundColor: 'rgba(76, 175, 80, 0.15)', 
                borderRadius: 2,
                border: '1px solid rgba(76, 175, 80, 0.3)'
              }}>
                <Typography variant="caption" sx={{ color: '#A5D6A7', fontWeight: 600 }}>
                  Hotel Code
                </Typography>
                <Typography variant="body2" sx={{ color: 'white', fontWeight: 'bold' }}>
                  {userInfo.hotelCode}
                </Typography>
              </Box>
              <Box sx={{ 
                textAlign: 'center', 
                p: 1.5, 
                backgroundColor: 'rgba(33, 150, 243, 0.15)', 
                borderRadius: 2,
                border: '1px solid rgba(33, 150, 243, 0.3)'
              }}>
                <Typography variant="caption" sx={{ color: '#90CAF9', fontWeight: 600 }}>
                  Role
                </Typography>
                <Typography variant="body2" sx={{ color: 'white', fontWeight: 'bold' }}>
                  {userInfo.role}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.15)', mx: 2, my: 1 }} />
          
          {/* Navigation */}
          <Box sx={{ flex: 1, overflowY: 'auto', pt: 1 }}>
            {renderMenuItems()}
          </Box>

          {/* Footer */}
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Chip 
              label={userInfo.hotel}
              size="small"
              sx={{ 
                backgroundColor: 'rgba(255, 215, 0, 0.25)',
                color: '#FFD700',
                fontWeight: 700,
                fontSize: '0.75rem',
                mb: 1,
                border: '1px solid rgba(255, 215, 0, 0.4)',
                height: 26
              }}
            />
            <Typography variant="caption" sx={{ 
              display: 'block', 
              color: '#81D4FA',
              fontWeight: 500,
              fontSize: '0.75rem'
            }}>
              e-Neurons Hospitality Management System
            </Typography>
          </Box>
        </Box>
      </Drawer>

      {/* Sidebar for desktop */}
      <Box
        sx={{
          width: 300,
          flexShrink: 0,
          backgroundColor: '#0A1929',
          backgroundImage: 'linear-gradient(180deg, #0A1929 0%, #132F4C 100%)',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          color: 'white',
          borderRight: '1px solid rgba(255, 255, 255, 0.15)',
          height: '100vh',
          position: 'sticky',
          top: 0,
          overflowY: 'auto',
          boxShadow: '4px 0 20px rgba(0, 0, 0, 0.25)',
        }}
      >
        {/* Header with user info */}
        <Box sx={{ p: 2, pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <img src={logo} alt="Hotel Logo" style={{ 
              width: 48, 
              height: 48, 
              marginRight: 12, 
              borderRadius: '12px',
              border: '2px solid rgba(255, 255, 255, 0.15)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)'
            }} />
            <Box>
              <Typography variant="h6" sx={{ 
                fontSize: '1.3rem', 
                fontWeight: 'bold', 
                color: '#FFFFFF',
                textShadow: '0 1px 3px rgba(0, 0, 0, 0.4)'
              }}>
               e-Neurons
              </Typography>
              <Typography variant="caption" sx={{ 
                color: '#B3E5FC',
                fontWeight: 600,
                fontSize: '0.8rem'
              }}>
                  Service Providers: {SERVICE_PROVIDERS}
              </Typography>
            </Box>
          </Box>
          
          {/* User profile */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            backgroundColor: 'rgba(255, 255, 255, 0.12)', 
            p: 1.5, 
            borderRadius: 3, 
            mb: 2,
            border: '1px solid rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)'
          }}>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              variant="dot"
              color="success"
            >
              <Avatar sx={{ 
                width: 48, 
                height: 48, 
                mr: 1.5,
                border: '2px solid rgba(255, 255, 255, 0.2)'
              }} src={userInfo.avatar}>
                {userInfo.name.charAt(0)}
              </Avatar>
            </Badge>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{ 
                fontWeight: 700, 
                color: '#FFFFFF',
                fontSize: '1rem'
              }}>
                {userInfo.name}
              </Typography>
             
              <Typography variant="caption" sx={{ 
                display: 'block',
                color: '#B2EBF2',
                fontWeight: 500,
                fontSize: '0.75rem'
              }}>
                Code: {userInfo.hotelCode}
              </Typography>
            </Box>
            <IconButton sx={{ 
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                transform: 'scale(1.05)',
              },
              transition: 'all 0.2s ease'
            }} size="small">
              <NotificationsIcon />
            </IconButton>
          </Box>
        </Box>

        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.15)', mx: 2, my: 1 }} />
        
        {/* Navigation */}
        <Box sx={{ flex: 1, overflowY: 'auto', pt: 1 }}>
          {renderMenuItems()}
        </Box>

        {/* Footer */}
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Chip 
            label={userInfo.hotel}
            size="small"
            sx={{ 
              backgroundColor: 'rgba(255, 215, 0, 0.25)',
              color: '#FFD700',
              fontWeight: 700,
              fontSize: '0.8rem',
              mb: 1,
              border: '1px solid rgba(255, 215, 0, 0.4)',
              height: 28
            }}
          />
          <Typography variant="caption" sx={{ 
            display: 'block', 
            color: '#81D4FA',
            fontWeight: 600,
            fontSize: '0.8rem'
          }}>
            Hotel Code: {userInfo.hotelCode}
          </Typography>
          <Typography variant="caption" sx={{ 
            display: 'block', 
            mt: 0.5, 
            color: '#4FC3F7', 
            fontSize: '0.7rem',
            fontWeight: 500
          }}>
            Powered by e-neurons Technologies Ltd
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default HotelSidebar;